import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase, ref, push, onValue, update } from "firebase/database";
import config from "../firebase.config";

export default class UserRepository {
    constructor() {
        const firebaseConfig = config;

        this.app = initializeApp(firebaseConfig);
        this.analytics = getAnalytics(this.app);
        this.db = getDatabase();
    }

    ref(path = "") {
        return ref(this.db, `userAccount${path}`);
    }

    getAllUsers(callback) {
        return onValue(this.ref(), (snapshot) => {
            const data = [];
            snapshot.forEach(function(childSnapshot) {
                data.push({ id: childSnapshot.key, ...childSnapshot.val() });
            });

            callback(data);
        });
    }

    getOneUser(id, callback) {
        return onValue(this.ref(`/${id}`), (snapshot) => {
            const data = snapshot.val();
            callback(data);
        });
    }
    
    updateUser(id, modelData) {
        update(this.ref(`/${id}`), {...modelData});
    }

}